<template>
  <div class="modal">
    <v-snackbar v-model="snackbar" timeout="3000"
      >Aktion erfolgreich ausgeführt.
    </v-snackbar>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        scrollable
        :fullscreen="$vuetify.breakpoint.xs ? true : false"
        :transition="
          $vuetify.breakpoint.xs
            ? 'dialog-bottom-transition'
            : 'dialog-transition'
        "
      >
        <v-card :disabled="loading">
          <v-card-title>
            <span class="headline">Frist verlängern</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close')">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text v-if="!showSuccess">
            <v-card
              v-if="
                deadlineEntry.deadline.proofPolicy === 'proofRequired' &&
                !helpers.proofExists &&
                !errorMessage
              "
              outlined
            >
              <v-card-title class="body-2"
                >Liegt ein (vorläufiger) Nachweis für diese Frist
                vor?</v-card-title
              >
              <v-card-text>
                <v-alert
                  v-if="deadlineEntry.deadline.proofHintText"
                  type="info"
                  dense
                  text
                >
                  {{ deadlineEntry.deadline.proofHintText }}
                </v-alert>
                <div class="pt-3">
                  <v-btn
                    class="mr-2"
                    depressed
                    @click="helpers.proofExists = true"
                    ><v-icon left>mdi-thumb-up-outline</v-icon>Ja</v-btn
                  >
                  <v-btn
                    depressed
                    @click="
                      errorMessage =
                        'Die Verlängerung des Fristeneintrags ist nur möglich, wenn ein (vorläufiger) Nachweis vorliegt.'
                    "
                    ><v-icon left>mdi-thumb-down-outline</v-icon>Nein</v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
            <v-card
              outlined
              v-if="
                deadlineEntry.deadline.proofPolicy !== 'proofRequired' ||
                (deadlineEntry.deadline.proofPolicy === 'proofRequired' &&
                  helpers.proofExists)
              "
            >
              <v-card-text>
                <v-form v-model="formIsValid" @submit.prevent>
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="deadlineEntryUpdate.dueDate"
                        type="date"
                        outlined
                        hide-details="auto"
                        label="Ablaufdatum"
                        :rules="[rules.required]"
                        class="mb-2"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <!-- Standardintervall{{ deadlineEntry.deadline.defaultInterval.value }}
                  {{
                    getIntervalText(deadlineEntry.deadline.defaultInterval.unit)
                  }} -->
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="deadlineEntryUpdate.labels"
                        :items="deadlineEntry.deadline.availableLabels"
                        outlined
                        multiple
                        small-chips
                        deletable-chips
                        clearable
                        hide-details="auto"
                        label="Labels"
                        class="mb-2"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model.trim="deadlineEntryUpdate.note"
                        outlined
                        hide-details="auto"
                        clearable
                        label="Bemerkungen"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-divider v-if="!hideNotifyUserOption"></v-divider>
              <v-card-text v-if="!hideNotifyUserOption">
                <v-checkbox
                  v-model="deadlineEntryUpdate.notifyUser"
                  hide-details="auto"
                  label="Benachrichtigung per E-Mail senden"
                  class="mt-0"
                ></v-checkbox>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-text
            v-if="
              deadlineEntry.deadline.updatePolicy === 'proposeUpdate' &&
              (deadlineEntry.deadline.proofPolicy !== 'proofRequired' ||
                (deadlineEntry.deadline.proofPolicy === 'proofRequired' &&
                  helpers.proofExists))
            "
          >
            <v-alert type="info" dense text
              >Für die Verlängerung deines Fristeneintrags ist ein
              Genehmigungsprozess festgelegt. Nach Genehmigung wird die
              Verlängerung übernommen.</v-alert
            >
            Es kann einige Minuten dauern, bis die Verlängerung der Frist
            angezeigt wird.
          </v-card-text>
          <v-card-text v-if="errorMessage !== ''">
            <v-alert dense text type="error"> {{ errorMessage }} </v-alert>
          </v-card-text>
          <v-card-actions
            v-if="
              deadlineEntry.deadline.proofPolicy !== 'proofRequired' ||
              (deadlineEntry.deadline.proofPolicy === 'proofRequired' &&
                helpers.proofExists)
            "
            class="mx-2 mb-1 pt-0"
          >
            <v-btn text @click="$emit('close')">Abbrechen</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              :loading="loading"
              depressed
              color="primary"
              @click="startUpdateOperation()"
            >
              Aktualisieren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { functions, Timestamp } from "@/firebase";
export default {
  name: "deadline-entry-update-dialog",
  props: {
    deadlineEntry: {
      type: Object,
      required: true,
    },
    hideNotifyUserOption: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Ist erforderlich.",
      },
      licenseKey: "",
      formIsValid: false,
      loading: false,
      showSuccess: false,
      errorMessage: "",
      dialog: true,
      snackbar: false,
      deadlineEntryUpdate: {
        dueDate: "",
        note: "",
        labels: [],
        documents: [],
        pendingUpdate: null,
        scheduledRenewal: null,
        user: null,
        notifyUser: true,
      },
      helpers: {
        proofExists: false,
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.organization.membership.user;
    },
  },
  methods: {
    getIntervalText(unit) {
      const intervalValues = [
        { text: "Tage", value: "days" },
        { text: "Wochen", value: "weeks" },
        { text: "Monate", value: "months" },
        { text: "Jahre", value: "years" },
      ];

      const found = intervalValues.find((interval) => interval.value === unit);
      return found ? found.text : "Unbekannte Einheit";
    },
    getDueTypeText(dueType) {
      const deadlineTypeValues = [
        { text: "Taggenaue Fälligkeit", value: "day" },
        { text: "Fälligkeit zum Monatsende", value: "month-end" },
        { text: "Fälligkeit zum Quartalsende", value: "quarter-end" },
        { text: "Fälligkeit zum Halbjahresende", value: "halfyear-end" },
        { text: "Fälligkeit zum Jahresende", value: "year-end" },
      ];

      const found = deadlineTypeValues.find((type) => type.value === dueType);
      return found ? found.text : "Unbekannter Typ";
    },
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
    startUpdateOperation() {
      this.loading = true;
      this.errorMessage = "";
      if (this.deadlineEntry.deadline.updatePolicy === "proposeUpdate") {
        this.suggestUpdate();
      } else if (this.deadlineEntry.deadline.updatePolicy === "selfUpdate") {
        this.directUpdate();
      } else {
        this.errorMessage =
          "Die Aktualisierung des Fristeneintrags ist nicht möglich.";
        this.loading = false;
      }
    },
    suggestUpdate() {
      const newDueDateTimestamp = this.convertToTimestamp(
        this.deadlineEntryUpdate.dueDate,
        "00:00"
      );
      const deadlineEntryObject = {
        user: {
          membershipId: this.user.membershipId,
          uid: this.user.uid,
          displayName: this.user.displayName,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          personnelNumber: this.user.personnelNumber,
          division: {
            id: this.user.division.id,
            title: this.user.division.title,
            shortTitle: this.user.division.shortTitle,
            sortKey: this.user.division.sortKey,
          },
        },
        dueDate: newDueDateTimestamp,
        labels: this.deadlineEntryUpdate.labels,
        note: this.deadlineEntryUpdate.note,

        documents: [], // TO DO: Add document handling
      };

      const callFunction = functions.httpsCallable(
        "memberManagement-addDeadlineEntryUpdateRequests"
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineId: this.deadlineEntry.deadline.id,
        deadlineEntries: [{ ...deadlineEntryObject }],
        // deadlineEntryUpdate: {
        //   ...deadlineEntryUpdateObject,
        // },
        notifyUser: this.deadlineEntryUpdate.notifyUser,
      })
        .then((result) => {
          console.log(result.data);
          if (result.data.success) {
            this.showSuccess = true;
            this.snackbar = true;
            this.loading = false;
            this.$emit("close");
          } else {
            this.errorMessage = "Unbekannter Fehler aufgetreten.";
            this.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          console.error(error);
          this.errorMessage = error.message;
          this.loading = false;
        });
    },
    directUpdate() {
      const newDueDateTimestamp = this.convertToTimestamp(
        this.deadlineEntryUpdate.dueDate,
        "00:00"
      );
      const deadlineEntryObject = {
        user: {
          membershipId: this.user.membershipId,
          uid: this.user.uid,
          displayName: this.user.displayName,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          personnelNumber: this.user.personnelNumber,
          division: {
            id: this.user.division.id,
            title: this.user.division.title,
            shortTitle: this.user.division.shortTitle,
            sortKey: this.user.division.sortKey,
          },
        },
        dueDate: newDueDateTimestamp,
        labels: this.deadlineEntryUpdate.labels,
        note: this.deadlineEntryUpdate.note,

        documents: [], // TO DO: Add document handling
        pendingUpdate: null,
        scheduledRenewal: null,
      };

      const callFunction = functions.httpsCallable(
        "memberManagement-addDeadlineEntries"
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineId: this.deadlineEntry.deadline.id,
        deadlineEntries: [{ ...deadlineEntryObject }],
      })
        .then((result) => {
          console.log(result.data);
          if (result.data.success) {
            this.showSuccess = true;
            this.snackbar = true;
            this.loading = false;
            this.$emit("close");
          } else {
            this.errorMessage = "Unbekannter Fehler aufgetreten.";
            this.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          console.error(error);
          this.errorMessage = error.message;
          this.loading = false;
        });
    },
  },
};
</script>
